import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { defineApiSlice } from './defineApiSlice';
export interface DefineState {
  type: 'create' | 'update';
  projectId?: number;
  target?:string | number;
  plusByUser?:number;
  percentage?:number;
  users?:any[],
  projectDetails: {
    projectName: string;
    projectDescription: string;
    // accoladeNo: string;
    // elevationChanges: string;
    // elevationMax: string;
  };
  shippingModes: Array<{
    id?:number,
    mode: number;
    transitMode: string;
    startCity: string;
    startStateName: string;
    startZip: string;
    endCity: string;
    endStateName: string;
    endZip: string;
    distanceTravelled: string;
    intermediateStepNotes?: string;
    elevationChanges: string;
    elevationMax: string;
    intermediateStopNotes?:string
  }>;
}

const initialState: DefineState = {
  type: 'create',
  projectId:undefined,
  target:2,
  plusByUser:6,
  percentage:0.7,
  projectDetails: {
    projectName: '',
    projectDescription: '',
  },
  shippingModes: [
    {
      mode: 1,
      transitMode: "",
      startCity: "",
      startStateName: "",
      startZip: "",
      endCity: "",
      endStateName: "",
      endZip: "",
      distanceTravelled: "",
      elevationChanges: "",
      elevationMax: "",
      intermediateStopNotes: "",
    }
  ],
};

const defineSlice = createSlice({
  name: 'define',
  initialState,
  reducers: {
    setDefineData: (state, action: PayloadAction<DefineState>) => {
      return { ...state, ...action.payload };
    },
    addShippingMode: (state, action: PayloadAction<DefineState['shippingModes'][0]>) => {
      state.shippingModes.push(action.payload);
    },
    removeShippingMode: (state, action: PayloadAction<number>) => {
      state.shippingModes.splice(action.payload, 1);
    },
    updateShippingMode: (state, action: PayloadAction<{ index: number; mode: DefineState['shippingModes'][0] }>) => {
      state.shippingModes[action.payload.index] = action.payload.mode;
    },
    setProjectId: (state, action) => {
      state.projectId= action.payload
    },
    setTarget: (state, action) => {
      state.target= action.payload
    },
    setProjectFtlFields:(state,action)=>{
      state.plusByUser=action.payload.plusByUser,
      state.percentage=action.payload.percentage
    }
  },
  extraReducers: (builder) => {
    // builder.addMatcher(defineApiSlice.endpoints.updateProjectTarget.matchFulfilled, (state, action) => {
    //   console.log(action.payload)
    //   state.target = action.payload.target
    // });
    builder.addMatcher(defineApiSlice.endpoints.getProjectDetails.matchFulfilled, (state, action) => {
      console.log(action.payload)
      state.target = action.payload.target
    });
  }
});

export const { setDefineData, addShippingMode, removeShippingMode, updateShippingMode,setProjectId ,setTarget,setProjectFtlFields} = defineSlice.actions;

export default defineSlice.reducer;
